import React from 'react';
import { useLocation } from 'react-router-dom';
import { ROUTES } from '../../core/routes';

const Layout = ({ children }) => {
  let isLandingPage = false;
  try {
    const location = useLocation();
    isLandingPage = location.pathname === ROUTES.LANDING;
  } catch (e) {
    // useLocation may throw if not inside a Router — default to showing footer
  }

  return (
    <>
      {children}
      {!isLandingPage && (
        <footer className="footer-layout text-center privacy-terms-link-wrapper">
          <a
            href="/privacy-policy"
          >
            Privacy
          </a>
          &nbsp;|&nbsp;
          <a
            href='/terms-and-conditions'
          >
            Terms & Conditions
          </a>
        </footer>
      )}
    </>
  );
};

export default Layout;